import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'utils/constants'
import axiosInstance, { microServices } from 'network/apis'

/**
 * Service to get user info
 */
export const getUserInfoService = (adminId) => {
  return axiosInstance(METHOD_TYPES.get, 'admins/details', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: { adminId }
  })
}

export const getUsersListService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/users/list', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getUserHandsService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/users/hands', {}, {
    server: microServices.USER_URL,
    loader: false,
    params: data
  })
}

export const getUserDetailsService = (userId) => {
  return axiosInstance(METHOD_TYPES.get, '/users/details', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: { userId }
  })
}

export const updateUserService = (data) => {
  return axiosInstance(METHOD_TYPES.put, '/users/update', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: 'userUpdatedSuccessfully'
  })
}

export const updateUserStatusService = (data) => {
  return axiosInstance(METHOD_TYPES.put, '/users/update-status', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: 'userStatusUpdatedSuccessfully'
  })
}

export const getOnlineUsersService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/users/online-users', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

/**
 * Service to update user info
 * @param {object} data - object contains name to be updated for user
 */
export const updateUserInfoService = (data) => {
  return axiosInstance(METHOD_TYPES.put, 'users/change-details', data, {
    server: microServices.USER,
    loader: LOADER_HANDLER_TYPES.submit
  })
}
